import React from 'react';
import {
    Card,
    CardContent,
    Typography,
    Box,
    Grid,
    Button,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EventIcon from '@mui/icons-material/Event';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const StyledCard = styled(Card)(({ theme }) => ({
    maxWidth: 400,
    margin: 'auto',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    borderRadius: theme.spacing(2),
    overflow: 'hidden',
}));

const CardHeader = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(2),
}));

const StyledCardContent = styled(CardContent)(({ theme }) => ({
    position: 'relative',
    paddingBottom: `${theme.spacing(2)} !important`,
}));

const PatientNumberCircle = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    width: 40,
    height: 40,
    borderRadius: '50%',
    backgroundColor: 'white',
    color: theme.palette.primary.main,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
    fontSize: '1.2rem',
    border: `2px solid ${theme.palette.primary.main}`,
}));

const InfoItem = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    '& .MuiSvgIcon-root': {
        marginRight: theme.spacing(1),
        color: theme.palette.primary.main,
    },
}));

const BookingCard = ({ booking, refreshDashboard }) => {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    // Function to handle cancellation
    const handleCancelBooking = async () => {
        const confirmation = window.confirm('Are you sure you want to cancel this booking?');
        if (confirmation) {
            try {
                const response = await fetch(`${apiUrl}/appointments/${booking.id}/cancel`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (response.ok) {
                    alert('Booking cancelled successfully');
                    refreshDashboard();  // Refresh the dashboard after successful cancellation
                } else {
                    console.error('Error cancelling the booking:', response.statusText);
                }
            } catch (error) {
                console.error('Error cancelling the booking:', error);
            }
        }

    };

    return (
        <StyledCard>
            <CardHeader>
                <Typography variant="h6">{booking.branch.location}</Typography>
            </CardHeader>
            <StyledCardContent>
                <PatientNumberCircle>{booking.slot_number}</PatientNumberCircle>
                <InfoItem>
                    <LocationOnIcon />
                    <Typography variant="body2">{`${booking.branch.suite}, ${booking.branch.street}`}</Typography>
                </InfoItem>
                <InfoItem>
                    <PhoneIcon />
                    <Typography variant="body2">{booking.branch.phone}</Typography>
                </InfoItem>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <InfoItem>
                            <EventIcon />
                            <Typography variant="body2">{booking.appointment_date}</Typography>
                        </InfoItem>
                    </Grid>
                    <Grid item xs={6}>
                        <InfoItem>
                            <AccessTimeIcon />
                            <Typography variant="body2">{booking.appointment_time}</Typography>
                        </InfoItem>
                    </Grid>
                </Grid>
                <Box sx={{ mt: 2, textAlign: 'center' }}>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleCancelBooking}
                    >
                        Cancel Appointment
                    </Button>
                </Box>
            </StyledCardContent>
        </StyledCard>
    );
};

export default BookingCard;
